// 获取推荐上车点列表
export const SearchGeocodeReGeo = {
  module: 'car',
  method: 'POST',
  address: 'api/guide/SearchGeocodeReGeo',
};
// 获取poi
export const POIPlaceText = {
  module: 'car',
  method: 'POST',
  address: 'api/guide/POIPlaceText',
};
// 获取城市列表
export const GetCityList = {
  module: 'car',
  method: 'POST',
  address: 'api/tc/GetCityList',
};
// 坐标转化
export const ConvertCoordinate = {
  module: 'car',
  method: 'POST',
  address: 'api/guide/ConvertCoordinate',
};
// 用车查价
export const QueryPrice = {
  module: 'car',
  method: 'POST',
  address: 'api/order/QueryPrice',
};
//验证是否可以下单
export const ValidTravelStandard = {
  module: 'car',
  method: 'POST',
  address: 'api/order/ValidTravelStandard',
};
//提交用车订单
export const SubmitOrderNew = {
  module: 'car',
  method: 'POST',
  address: 'api/order/SubmitOrderNew',
};
//隐藏推荐地址
export const HideRecommendAddress = {
  module: 'car',
  method: 'POST',
  address: 'api/order/HideRecommendAddress',
};
